import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Switch from "@mui/material/Switch";
import { useGame, useUpdateGameV2 } from "@seabrookstudios/pitch2table";
import CircularProgress from "@mui/material/CircularProgress";

const PublicText = "Anyone with the links below can view this game.";
const PrivateText = "The links below are off.";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const GameVisibilityControl = ({ gameId }) => {
  const updateGame = useUpdateGameV2(gameId);
  const { data: game } = useGame(gameId);

  /**
   * @param {import("@seabrookstudios/pitch2table-core").VisibilityTypes} visibility
   */
  const updateVisibility = (visibility) => {
    updateGame.mutate({
      visibility,
      sizzle: undefined,
      bgg: undefined,
      personalGoal: undefined,
      customAuthors: undefined,
      gameType: undefined,
      referenceId: undefined,
      tags: undefined,
      feedbackEnabled: undefined,
    });
  };

  const onChangeHandler = (e) => {
    updateVisibility(e.target.checked ? "Public" : "Private");
  };

  if (!game) {
    return <CircularProgress />;
  }

  return (
    <ListItem>
      <ListItemText primary="Visibility" secondary={game.visibility === "Public" ? PublicText : PrivateText} />
      <ListItemButton style={{ justifyContent: "flex-end" }}>
        <Switch defaultChecked={game.visibility === "Public"} onChange={onChangeHandler} />
      </ListItemButton>
    </ListItem>
  );
};
